<template>
  <label class="form-toggle-field">
    <input
      type="checkbox"
      :true-value="trueValue"
      :false-value="falseValue"
      @change="onChange"
      v-model="local"
      :readonly="readonly"
    >
    <span class="form-toggle__indicator"></span>
    <span class="form-toggle__description"></span>
  </label>
</template>

<script>
export default {
  props: {
    value: { type: [String, Number], required: true },
    // name: { type: String, required: true },
    // error: { type: Object, required: true },
    // type: { type: String, default: 'text' },
    readonly: { type: Boolean, default: false },
    // placeholder: { type: String, default: '' },
    // helpText: { type: String, default: '' },
    trueValue: { type: [String, Boolean], default: true },
    falseValue: { type: [String, Boolean], default: false }
  },
  data () {
    return {
      local: this.value
    }
  },
  watch: {
    value () {
      this.local = this.value
    }
  },
  methods: {
    onChange ($event) {
      // console.log('$event.target.checked', $event.target.checked, this.local)
      // this.$emit('change', $event.target.checked)
      // this.$emit('input', $event.target.checked)
      this.$emit('input', this.local)
      this.$emit('change', this.local)
    }
  }
}
</script>
